// extracted by mini-css-extract-plugin
var _1 = "flexRoot___JkCLP";
export { _1 as "flexRoot" }
